import React from 'react';
import PersonalAccount from '../../../../../components/ui/PersonalAccount/PersonalAccount';
import { Modal } from 'antd';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useFlatAccounts from '../../../../../queries/useFlatAccounts';
import useFlatsGridState from '../../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../../hooks/useHousingStockState';
import { texts } from '../../../../../constants/texts';
import styles from '../Flat.module.scss'
import deleteFlatAccount from '../../../../../requests/deleteFlatAccount';

const { confirm } = Modal;

const FlatPersonalAccount = () => {
  const queryClient = useQueryClient();

  const params = useParams();

  const addressId = Number(params.pageTabId);

  const { data: accounts, isFetching: isAccountsFetching } =
    useFlatAccounts(addressId);

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const handleDeleteAccount = (accountData) => {
    confirm({
      title: 'Удалить лицевой счет?',
      content: (
        <>
          <div
            style={{
              fontSize: 15,
              fontWeight: 500,
              color: '#555',
              margin: '20px 0px 5px 0px',
            }}
          >
            {accountData.account}
          </div>
          <div style={{ fontSize: 15, fontWeight: 500, color: '#006f2d' }}>
            {accountData.type.name}
          </div>
        </>
      ),

      onOk: async () => {
        const res = await deleteFlatAccount(accountData.bindId);

        if (!res.result) {
          queryClient.setQueryData([`flatAccounts`, addressId], (accounts) =>
            accounts.filter((account) => account.bindId !== accountData.bindId)
          );

          queryClient.invalidateQueries(flatsGridQueryKey);
          queryClient.invalidateQueries(housingStockQueryKey);
        }
      },

      onCancel: () => {},
    });
  };

  return (
    <PersonalAccount 
      accounts={accounts}
      className={styles.grow}
      title={texts.flatAccountsPersone}
      loading={isAccountsFetching}
      onDeleteAccount={handleDeleteAccount}
     />
  )
}

export default FlatPersonalAccount;